import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import Link from '@mui/material/Link';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSetPasswordViewController } from '../../controllers';

export const SetPasswordView = () => {
  const {
    showPassword,
    errors,
    formValues,
    linkInvalid,
    handleChange,
    handleClickShowPassword,
    handleMouseDownPassword,
    handleSetPassword,
    navigateToLogin,
    navigateToForgotPassword,
  } = useSetPasswordViewController();

  if (linkInvalid) {
    return (
      <Stack
        direction="row"
        width="100%"
        height="100vh"
        alignItems="center"
        justifyContent="center"
      >
        <Stack width={400} p={5} justifyContent="center">
          <Typography variant="h4" component="div" fontWeight="fontWeightSemiBold" mb={2.5}>
            Link Already Used
          </Typography>
          <div>This link only works one time and has already been used or has expired.</div>
          <Link
            component="button"
            variant="body2"
            style={{ textAlign: 'left', marginTop: '20px' }}
            onClick={navigateToLogin}
          >
            Back to Login
          </Link>
          <Link
            component="button"
            variant="body2"
            style={{ textAlign: 'left', marginTop: '8px' }}
            onClick={navigateToForgotPassword}
          >
            Request a new link
          </Link>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack direction="row" width="100%" height="100vh" alignItems="center" justifyContent="center">
      <Stack width={400} p={5} justifyContent="center">
        <Typography variant="h4" component="div" fontWeight="fontWeightSemiBold" mb={2.5}>
          Set Password
        </Typography>
        <FormControl variant="outlined" style={{ margin: '0px 0px 20px 0px' }}>
          <InputLabel htmlFor="outlined-adornment-password" error={!!errors?.password}>
            Password
          </InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={formValues.password}
            error={!!errors?.password}
            onChange={handleChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            name="password"
            label="Password"
          />
          <FormHelperText id="component-error-text" error>
            {errors.password || ''}
          </FormHelperText>
        </FormControl>
        <Button variant="contained" size="large" onClick={handleSetPassword}>
          Submit
        </Button>
      </Stack>
    </Stack>
  );
};
